"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var debug_1 = __importDefault(require("debug"));
var services_1 = require("../services");
var utils_1 = require("../utils");
var MAX_RETRY_COUNT = 3;
// const DEFAULT_TIMEOUT = 15000;
var DEFAULT_DELAY_LOADING = 0;
var DELAY_RETRY = 0;
var debugSuccess = debug_1.default('services:withAsyncLoad:success');
var debugFail = debug_1.default('services:withAsyncLoad:fail');
function withAsyncLoad(options, loadFn) {
    if (loadFn === void 0) { loadFn = load; }
    if (!options.loading) {
        throw new Error('react-loadable requires a `loading` component');
    }
    var defaultOptions = {
        loader: null,
        delay: 200,
        // timeout: DEFAULT_TIMEOUT,
        timeout: null,
        delayLoading: DEFAULT_DELAY_LOADING,
        render: render,
        withRetryLoad: false,
    };
    var opts = __assign(__assign({}, defaultOptions), options);
    var res = null;
    function init(retryCount) {
        if (!res) {
            res = loadFn(opts.loader, opts.delayLoading, opts.timeout || null, retryCount);
        }
        return res.promise;
    }
    function retry(retryCount) {
        return loadFn(opts.loader, DELAY_RETRY, opts.timeout || null, retryCount);
    }
    return /** @class */ (function (_super) {
        __extends(Loadable, _super);
        function Loadable(props) {
            var _this = _super.call(this, props) || this;
            _this.retryCounter = 0;
            _this.startPastDelayCountdown = function () {
                if (typeof opts.delay === 'number') {
                    if (opts.delay === 0) {
                        _this.setState({
                            pastDelay: true,
                        });
                    }
                    else {
                        _this.delayTimerId = setTimeout(function () {
                            _this.setState({
                                pastDelay: true,
                            });
                        }, opts.delay);
                    }
                }
            };
            _this.listenToResponse = function (response) {
                response.promise
                    .then(function () {
                    /* cache out last successful response */
                    res = response;
                    clearTimeout(_this.delayTimerId);
                    _this.update(response);
                    var msg = "[Chunk] Successfully loaded for " + options.loader.name;
                    debugSuccess(msg);
                })
                    .catch(function (error) {
                    /* no need to retry if error wasn't thrown by timer */
                    _this.retryCounter++;
                    debugFail(error);
                    if (error.timedOut &&
                        opts.withRetryLoad &&
                        _this.retryCounter <= MAX_RETRY_COUNT) {
                        var newResponse = retry(_this.retryCounter);
                        _this.update(newResponse);
                        _this.listenToResponse(newResponse);
                    }
                    else {
                        _this.update(response);
                        debugFail("[Chunk] Failed to load for " + options.loader.name);
                        /* to try load module next time */
                        res = null;
                    }
                });
            };
            _this.update = function (response) {
                if (!_this.mounted) {
                    /* avoid triggering state (because of promise)
                    withing not mounted component yet */
                    return;
                }
                _this.setState({
                    error: response.error,
                    loaded: response.loaded,
                    loading: response.loading,
                    timedOut: response.timedOut,
                });
            };
            init(_this.retryCounter);
            _this.listenToResponse(res);
            _this.startPastDelayCountdown();
            _this.mounted = false;
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: res.timedOut,
                loading: res.loading,
                loaded: res.loaded,
            };
            return _this;
        }
        Loadable.preload = function () {
            var promise = init(0);
            promise
                .then(function () {
                /* cache out last successful response */
                var msg = "[Chunk] Successfully loaded for " + options.loader.name;
                debugSuccess('preload', msg);
            })
                .catch(function (error) {
                /* no need to retry if error wasn't thrown by timer */
                debugFail('preload', error);
                console.error(error);
                res = null;
            });
        };
        Loadable.prototype.UNSAFE_componentWillMount = function () {
            this.mounted = true;
        };
        Loadable.prototype.componentWillUnmount = function () {
            this.mounted = false;
            clearTimeout(this.delayTimerId);
        };
        Loadable.prototype.render = function () {
            var _a = this.state, loading = _a.loading, loaded = _a.loaded, error = _a.error, pastDelay = _a.pastDelay, timedOut = _a.timedOut;
            if (loading || error) {
                return opts.loading(this.props, {
                    isLoading: loading,
                    pastDelay: pastDelay,
                    timedOut: timedOut,
                    error: error,
                });
            }
            else if (loaded) {
                if (hasComponentToRender(opts)) {
                    var Component = resolve(loaded).components[opts.componentToRender];
                    return react_1.default.createElement(Component, __assign({}, this.props));
                }
                return opts.render(loaded, this.props);
            }
            else {
                return null;
            }
        };
        return Loadable;
    }(react_1.default.Component));
}
exports.default = withAsyncLoad;
function render(loaded, props) {
    return react_1.default.createElement(resolve(loaded), props);
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function hasComponentToRender(opts) {
    var componentToRender = opts.componentToRender;
    return componentToRender && typeof componentToRender === 'string';
}
function load(loader, delayLoading, timeout, retryCount) {
    var state = {
        loading: true,
        loaded: null,
        error: null,
        timedOut: false,
    };
    var promise = delayLoading && !loader.isLoaded
        ? new Promise(function (res, rej) {
            setTimeout(function () {
                loader()
                    .then(function (v) { return res(v); })
                    .catch(function (e) { return rej(e); });
            }, delayLoading);
        })
        : loader();
    /* add promise if need one */
    var allPromisesArray = [promise];
    if (typeof timeout === 'number') {
        /* must wait longer than delay at least */
        var summedTimeout_1 = timeout + delayLoading;
        /* create promise if need one */
        var timeoutPromise = new Promise(function (_, reject) {
            setTimeout(function () {
                state.timedOut = true;
                var msg = retryCount === 0
                    ? 'Initial or preload request.'
                    : "Retry count: " + retryCount;
                reject(new utils_1.TimeoutError("[Chunk] Time's up for " + loader.name + ". " + msg));
            }, summedTimeout_1);
        });
        allPromisesArray.push(timeoutPromise);
    }
    state.promise = Promise.race(allPromisesArray)
        .then(function (loaded) {
        state.loading = false;
        state.loaded = loaded;
        loader.isLoaded = true;
        return loaded;
    })
        .catch(function (err) {
        state.loading = false;
        state.error = err;
        services_1.sentryHub.withScope(function (scope) {
            scope.setExtras({
                loader: loader.name,
            });
            scope.setTag('react-component', 'withAsyncLoad');
            services_1.sentryHub.captureException(err);
        });
        throw err;
    });
    return state;
}
//# sourceMappingURL=withAsyncLoad.js.map